import { getTabs } from '@/api/admin/import-type';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { tabConfig } from './tabConfig';
import { BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage, Breadcrumb } from '@/components/ui/breadcrumb';
import { Slash } from 'lucide-react';

export function AdminTabs() {
	const nav = useNavigate();
	const importTypeId = parseInt(window.location.pathname.split('/').pop()!);

	const {
		data: allowedTabsData,
		isLoading,
		isError,
	} = useQuery({
		queryKey: ['admin-tabs', importTypeId],
		queryFn: () => getTabs(importTypeId),
	});

	const allowedTabs = allowedTabsData?.tabs ?? [];
	const availableTabs = allowedTabs.filter((t) => tabConfig[t]);
	const defaultTab = availableTabs[0];

	if (isLoading) {
		return <p>Loading...</p>;
	}

	if (isError || !availableTabs.length) {
		return <p className="font-semibold text-red-500">No mappings available</p>;
	}

	return (
		<>
			<Breadcrumb className="mb-4 pl-4">
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink href="/admin">
							Import Types
						</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator>
						<Slash />
					</BreadcrumbSeparator>
					<BreadcrumbItem>
						<BreadcrumbPage>Mappings</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			<Tabs
				defaultValue={defaultTab}
			>
				<TabsList className={`grid w-full grid-flow-col auto-cols-fr`}>
					{availableTabs.map((key) => (
						<TabsTrigger key={key} value={key}>
							{tabConfig[key].label}
						</TabsTrigger>
					))}
				</TabsList>

				{availableTabs.map((key) => {
					const Comp = tabConfig[key].component;
					return (
						<Comp
							key={key}
							importTypeId={importTypeId}
							importTypeName={allowedTabsData?.importTypeName ?? ''}
						/>
					);
				})}
			</Tabs>
		</>
	);
}
